import Button from '@/components/units/button/Button';
import InvestmentCardField from '../InvestmentCardField';
import BankCardImg from '../../../../assets/images/bank-card-img.svg';
import { maskBankAccountNumber } from '@/utility/formatter';
import { navigateToURL } from '@/utility/navigate';

import Icon from '@/components/units/Icon';

import { useNotification } from '@/libraries/notification/NotificationContext';
import { NOTIFICATION } from '@/constants';

const TDWEBSITE_BASE = import.meta.env.VITE_TDWEBSITE_BASE;

export const BankDetailsCardContent = ({ data }) => {
  const { sendNotification: sendToast } = useNotification(NOTIFICATION.TOAST);

  const handleCopybankAccountDetails = (value) => {
    // TODO: Add Toast
    navigator.clipboard.writeText(value);
    sendToast({
      title: 'Copied',
      clearExisting: true,
    });
  };

  const navigateToOpenBankAccount = () => {
    navigateToURL(`${TDWEBSITE_BASE}/download-3-in-1-app`);
  };

  if (data?.bankAccountNumber) {
    return (
      <>
        <div className="tw-flex tw-flex-col tw-justify-start tw-w-full">
          {data?.bankAccountNumber && (
            <div className="tw-flex tw-gap-3">
              {maskBankAccountNumber(data?.bankAccountNumber)}
              <Icon
                iconName="copy-text"
                onClick={() => handleCopybankAccountDetails(data?.bankAccountNumber)}
              />
            </div>
          )}
        </div>
        <div className="tw-w-full tw-flex tw-grow tw-flex-col xs:tw-gap-1 sm:tw-gap-2 tw-justify-between">
          <div className="tw-flex tw-flex-grow tw-flex-col xs:tw-flex-row tw-justify-between">
            <InvestmentCardField label="Total Balance" primaryValue={data.balance} withTypography />
          </div>
          {data?.balance == 0 ? (
            <>
              <div className="tw-flex tw-flex-grow tw-justify-center place">
                <Button
                  variant="white-primary"
                  rounded="full"
                  size="lg"
                  className="tw-font-dmsanssemibold"
                  onClick={() => navigateToURL('/digital-bank/dashboard/add-money')}
                >
                  <Icon iconName="wallet" wrapperStyle="tw-cursor-pointer" />
                  Add Money
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="tw-flex tw-flex-grow tw-flex-col xs:tw-flex-row tw-justify-between ">
                <InvestmentCardField
                  label="Net Available Balance"
                  primaryValue={data.availableBalance}
                />
                <InvestmentCardField
                  label="Blocked Amount"
                  primaryValue={data.blockedAmount}
                  alignment="right"
                />
              </div>
              <div className="tw-flex tw-flex-grow tw-justify-center">
                <Button
                  variant="orange-primary"
                  rounded="full"
                  size="lg"
                  className="tw-font-dmsanssemibold"
                  onClick={() => navigateToURL('/digital-bank')}
                >
                  <Icon iconName="wallet" wrapperStyle="tw-cursor-pointer" />
                  View Details
                </Button>
              </div>
            </>
          )}
        </div>
      </>
    );
  } else {
    return (
      <div className="tw-flex-1 tw-w-full tw-flex tw-flex-col tw-items-stretch tw-overflow-hidden">
        <div className="tw-flex tw-items-start tw-text-2xl skeleton-block">Earn</div>
        <div className="tw-flex tw-justify-between">
          <div className="tw-flex tw-flex-col ">
            <div className="tw-text-[38px] tw-flex tw-items-start">
              <div className="tw-font-npmed">7.75%*</div>
              <div className="tw-text-[24px] tw-mb-2">p.a.</div>
            </div>
            <div className="tw-text-[16px] tw-mb-2">
              interest on your Torus Digital Savings Account
            </div>
          </div>
          <img src={BankCardImg} alt="" className="tw-h-full tw-hidden xs:tw-block" />
        </div>
        <div className="tw-flex tw-flex-grow tw-justify-center">
          <Button rounded onClick={() => navigateToOpenBankAccount()}>
            Open Savings Account
          </Button>
        </div>
      </div>
    );
  }
};
